import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {runInAction } from "mobx"
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";
import type {NewSearchWidgetState} from "../models/new-search-widget.state";
import {debounce} from "../../../infrastructure/debounce/debounce";
import type {NewSearchWidgetController} from "../new-search-widget.controller";

export class NewSearchWidgetSportTypeClickHandler extends ActionHandler {
  controller: NewSearchWidgetController;
  state: NewSearchWidgetState;
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSportTypeClick;

  static injectables = [...ActionHandler.injectables];

  constructor() {
    super();

    this.searchFetch = debounce(() => this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.FETCH.onSearchFetch, {query: this.state.query}), 250);
  }

  async action(params) {
    runInAction(() => {
      this.state.selectedSportId = params.id;

      if(!params.isReset) {
        this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.ANALYTICS.onSportTypeClickEvent, params)
      }

      if(this.state.query?.length > NEW_SEARCH_WIDGET.minimumCharacters) {
        this.searchFetch()
      }
    })
  }
}
